import axios from 'axios';


const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
})



export class EcommerceContentFetchAPI {

        //Function to get ecommerce content by business id
        static async getEcommerceContentByBusiness(business_id, token) {
            const res = await server(`/ecommerce/${business_id}/content`, {
                method: "get",
                headers: token ? { 'x-access-token': token } : undefined,
            })
            return res
        }

}